module.exports = __webpack_public_path__ + "static/media/Logo-SofttekWhite.378639f4.svg";